<template>
  <router-link tag="li" :to="{name: route.name}"
               :class="{'is-opened': isOpened, 'is-children': children.length}"
               :event="''"
               @click.native.stop="handleRouteTo">
    <button type="button">
      <span class="link-icon" :class="`icon-${route.meta.icon}`" v-if="route.meta.icon"/>
      <span class="title">{{L10n(route.meta.label)}}</span>
      <span class="children" v-if="children.length">
        {{childrenMap}}
      </span>
    </button>
    <ul v-if="children.length || isOpened">
      <LeftNavigationItem v-for="item in children" :key="item.name" :route="item" :user="user" @change-nav-rout="$emit('change-nav-rout')" class="router-child"/>
    </ul>
  </router-link>
</template>

<script>
export default {
  name: 'LeftNavigationItem',
  props: {
    route: { type: Object, required: true },
    user: { type: Object, required: true }
  },
  data () {
    return {
      isOpened: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.get('permissions')
    },
    children () {
      if (this.route.children) {
        return this.route.children
          .filter(item => !item.meta.hide && (!item.meta.permission || this.permission(this.permissions, item.meta.permission)))
      } else {
        return []
      }
    },
    childrenMap () {
      return this.children
        .slice(0, 5)
        .map(val => this.L10n(val.meta.label))
        .join(', ')
    }
  },
  methods: {
    handleRouteTo () {
      if (!this.children.length) {
        this.$emit('change-nav-rout')
        this.$router.push({ name: this.route.name })
      } else {
        this.isOpened = !this.isOpened
      }
    }
  }
}
</script>
<style lang="stylus">
  .router-child{
    &.router-link-active{
      .title {
        font-weight bold
        color #09729b
      }
    }
  }
</style>
